import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  city: string;
  text: string;
  initial: string;
}
export function TestimonialCard({
  name,
  city,
  text,
  initial
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 h-full flex flex-col" data-id="element-29">
      <div className="flex items-center gap-4 mb-4" data-id="element-30">
        <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-sm" data-id="element-31">
          {initial}
        </div>
        <div data-id="element-32">
          <h4 className="font-bold text-gray-900" data-id="element-33">{name}</h4>
          <p className="text-sm text-gray-500" data-id="element-34">{city}</p>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-35">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-36" />)}
      </div>

      <p className="text-gray-600 italic leading-relaxed flex-1" data-id="element-37">"{text}"</p>
    </div>;
}